import '../../../common/dashboard/filters/applied/applied_filter_view.js.coffee'
Namespace 'CustomerVisualMode.Filters.Applied'

class CustomerVisualMode.Filters.Applied.AppliedStatusFilterView extends Common.Dashboard.Filters.AppliedFilterView

  _displayTitle: ->
    I18n.t('customer_visual_mode.filters.status')

  _getSelectedValues: ->
    @filter._valuesToJSON()
